export const TABLE_RECORD_SIZE = 12;
